import {
	BrokerProjectsTabValue,
	brokerProjectsTabValues,
	BrokerStatus,
} from "@dune/types";

export const brokerStatusStyles: Record<BrokerStatus, string> = {
	NEW: "border-blue-badge-border bg-blue-badge-background text-blue-badge-text",
	ACTIVE:
		"border-green-badge-border bg-green-badge-background text-green-badge-text",
	PROGRESS:
		"border-yellow-badge-border bg-yellow-badge-background text-yellow-badge-text",
	CANCELLED:
		"border-red-badge-border bg-red-badge-background text-red-badge-text",
	TO_ANALYZE:
		"border-purple-badge-border bg-purple-badge-background text-purple-badge-text",
	TO_SIGN:
		"border-indigo-badge-border bg-indigo-badge-background text-indigo-badge-text",
	TO_RENEW:
		"border-orange-badge-border bg-orange-badge-background text-orange-badge-text",
} as const;

const brokerProjectsTabSet = new Set<string>(brokerProjectsTabValues);

export const isBrokerProjectsTab = (
	value: string,
): value is BrokerProjectsTabValue => {
	return brokerProjectsTabSet.has(value);
};